var render = function render(){
  var _vm$formEvento$evento;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('div', {
    staticClass: "pa-6"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.nome,
      "label": "Nome do Calendário",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.anoCalendario,
      "label": "Ano Calendário",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.periodo,
      "label": "Período do Calendário",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.diasLetivos,
      "label": "Dias Letivos",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.vigente ? 'Sim' : 'Não',
      "label": "Calendário Vigente",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6 mb-2",
    attrs: {
      "justify": "center"
    }
  }, [!_vm.isView ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.adicionarEvento
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-calendar-plus")]), _vm._v(" Adicionar Evento ")], 1) : _vm._e()], 1)], 1)])], 1), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: _vm.dialogAdicionarEvento,
      callback: function ($$v) {
        _vm.dialogAdicionarEvento = $$v;
      },
      expression: "dialogAdicionarEvento"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" Adicionar Evento ao Calendário ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.salvarEvento.apply(null, arguments);
      }
    }
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('sca-date-picker', {
    attrs: {
      "cols": 6,
      "label": "Data do Evento*",
      "allowedDates": _vm.permitirSomenteAnoCalendario,
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.formEvento.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.formEvento, "dataInicio", $$v);
      },
      expression: "formEvento.dataInicio"
    }
  }), _c('sca-date-picker', {
    attrs: {
      "cols": 6,
      "label": "Data Fim do Evento*",
      "allowedDates": _vm.permitirSomenteAnoCalendario,
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.formEvento.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.formEvento, "dataFim", $$v);
      },
      expression: "formEvento.dataFim"
    }
  })], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.eventos,
      "item-text": "nome",
      "item-value": "id",
      "label": "Eventos*",
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "return-object": "",
      "multiple": "",
      "chips": ""
    },
    model: {
      value: _vm.formEvento.eventosSelecionados,
      callback: function ($$v) {
        _vm.$set(_vm.formEvento, "eventosSelecionados", $$v);
      },
      expression: "formEvento.eventosSelecionados"
    }
  })], 1)], 1), (_vm$formEvento$evento = _vm.formEvento.eventosSelecionados) !== null && _vm$formEvento$evento !== void 0 && _vm$formEvento$evento.length ? _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Eventos Selecionados")]), _c('v-chip-group', {
    attrs: {
      "active-class": "primary--text",
      "column": ""
    }
  }, _vm._l(_vm.formEvento.eventosSelecionados, function (evento) {
    return _c('v-chip', {
      key: evento.id,
      attrs: {
        "color": evento.corHexadecimal,
        "dark": ""
      }
    }, [_vm._v(" " + _vm._s(evento.nome) + " ")]);
  }), 1)], 1)], 1) : _vm._e(), _c('sca-buttons', {
    attrs: {
      "actionText": 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvarEvento();
      },
      "cancel": function ($event) {
        return _vm.cancelarEvento();
      }
    }
  })], 1)], 1)], 1)], 1), _c('sca-calendario', {
    attrs: {
      "eventos": _vm.eventosCalendario,
      "anoCalendario": _vm.content.anoCalendario,
      "isView": _vm.isView,
      "start": _vm.inicioVisualizacao
    },
    on: {
      "removerEvento": _vm.excluirEventoCalendario
    }
  }), _c('sca-buttons', {
    attrs: {
      "showAction": false,
      "showCancel": true,
      "cancelText": "Voltar"
    },
    on: {
      "cancel": function ($event) {
        return _vm.voltar();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }